import { Alert, AlertIcon, Box } from '@chakra-ui/react';
import Field from 'components/general/Field';
import { useFormContext, useWatch } from 'react-hook-form';

function NewClientForm({ isEdit = false }: { isEdit?: boolean }) {
  const { control } = useFormContext();
  const leaseApplication = useWatch({ control, name: 'leaseApplication' });

  return (
    <Box>
      <Field
        name="firstName"
        label="First Name"
        register={{ required: 'First Name is required' }}
      />
      <Field
        name="lastName"
        label="Last Name"
        register={{ required: 'Last Name is required' }}
        mt={4}
      />
      <Field
        name="email"
        label="Email"
        type="email"
        register={{
          required: 'Email is Required',
          pattern: { value: /\S+@\S+\.\S+/, message: 'Email has incorrect format' },
        }}
        mt={4}
      />
      {!isEdit && (
        <Field name="leaseApplication" label="Send lease application" type="checkbox" mt={10} />
      )}

      {!isEdit && leaseApplication && (
        <Alert status="warning" mt={10} mb={4}>
          <AlertIcon />
          By clicking &quot;Send&quot; below, an email will be sent to the client with a link to
          complete the lease application.
        </Alert>
      )}
    </Box>
  );
}

export default NewClientForm;
